import { render, staticRenderFns } from "./myheader.vue?vue&type=template&id=60b51978&scoped=true&"
import script from "./myheader.vue?vue&type=script&lang=js&"
export * from "./myheader.vue?vue&type=script&lang=js&"
import style0 from "./myheader.vue?vue&type=style&index=0&id=60b51978&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b51978",
  null
  
)

export default component.exports